<div class="note-overlay" [class.open]="open" (click)="closePanel.emit()"></div>

<div class="note-panel" [class.open]="open" role="dialog" aria-modal="true" aria-label="Notifications">
  <div class="note-sheet">
    <div class="note-sheet__top">
      <div class="note-sheet__title-row">
        <h2>Notifications</h2>
        <button type="button" class="note-close" (click)="closePanel.emit()" aria-label="Close notifications">×</button>
      </div>
      @if (notificationsService.items().length) {
        <button type="button" class="note-mark" (click)="markAllRead()">Mark all read</button>
      }
    </div>

    <div class="note-sheet__body">
      @if (!notificationsService.items().length) {
        <div class="note-empty" @fadeInUp>
          <div class="note-empty-icon" aria-hidden="true">🔔</div>
          <h3>No notifications</h3>
          <p>You’re all caught up. New updates will show up here.</p>
        </div>
      } @else {
        <div @staggerIn>
          @for (n of notificationsService.items(); track n.id) {
            <a class="note-item anim-stagger-item" [class.read]="n.read" [routerLink]="n.link || '/home'" (click)="closePanel.emit()">
              <div class="note-dot" aria-hidden="true"></div>
              <div>
                <strong>{{ n.title }}</strong>
                <p>{{ n.body }}</p>
                <time>{{ n.at | date: 'd MMM y, h:mm a' }}</time>
              </div>
            </a>
          }
        </div>
      }
    </div>
  </div>
</div>
